module.exports = __webpack_public_path__ + "media/images/carousel/metier-image-4-0fc7eae5199e85a9c211a17d604c8a73.jpg";